<template>
	<div>
		<div>
			<!-- <img src="../../assets/headImg/headimg.jpg" style="width: 100%;" /> -->
			<div class="head">
				<img src="@/assets/headImg/headimg.jpg" style="width: 100%;
			vertical-align:top;" />
				<div class="retrun" @click="retrun" style="margin-left: 10px;">
					返回
				</div>
			</div>
		</div>

		<div class="zhucbox">
			<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">

				<el-form-item label="手机号码" prop="phoneNumber">
					<el-input v-model.number="ruleForm.phoneNumber" placeholder="请输入手机号码"></el-input>
				</el-form-item>

				<el-form-item label="密码" prop="pass">
					<el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="请输入密码"></el-input>
				</el-form-item>

				<el-form-item label="确认密码" prop="checkPass">
					<el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" placeholder="请再次输入密码">
					</el-input>
				</el-form-item>

				<el-form-item label="真实姓名" prop="name">
					<el-input v-model="ruleForm.name" placeholder="请输入姓名"></el-input>
				</el-form-item>

				<el-form-item label="身份证号" prop="id" v-if="state != 1">
					<el-input v-model="ruleForm.id" placeholder="请输入身份证号"></el-input>
				</el-form-item>

				<el-form-item label="专业" prop="field">
					<!-- 	<el-input v-model.number="ruleForm.age"></el-input> -->
					<el-select v-model="ruleForm.field" placeholder="请选择专业" style="width: 100%;">
						<el-option v-for="item in major" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="电子邮箱" prop="mailbox">
					<el-input v-model="ruleForm.mailbox" placeholder="请输入电子邮箱"></el-input>
				</el-form-item>

				<el-form-item label="所属地区" prop="province">
					<div style="margin-top: 40px;"></div>
					<v-distpicker @selected="selected"></v-distpicker>
				</el-form-item>

				<el-form-item label="工作单位" prop="company">
					<el-input v-model="ruleForm.company" placeholder="请输入工作单位"></el-input>
				</el-form-item>

				<el-form-item label="通讯地址" prop="postalAddress">
					<el-input v-model="ruleForm.postalAddress" placeholder="请输入通讯地址"></el-input>
				</el-form-item>

				<el-form-item label="科室/部门" prop="department">
					<el-input v-model.number="ruleForm.department" placeholder="请输入科室/部门"></el-input>
				</el-form-item>

				<el-form-item label="职称" prop="title">
					<el-select v-model="ruleForm.title" placeholder="请选择职称" style="width: 100%;">
						<el-option v-for="item in titleList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>

				<!-- <el-form-item label="出生日期" prop="birthday">
					<div class="block">
						<el-date-picker v-model="ruleForm.birthday" type="date" placeholder="选择日期">
						</el-date-picker>
					</div>
				</el-form-item> -->
				<el-form-item label=" " prop="rootUnit">

					<div class="flex">
						<span style="margin-right: 1.25rem;color: #535353;">是否来自基层(县级以下、社区等医疗卫生机构)</span>
						<el-radio v-model="ruleForm.rootUnit" label="是">是</el-radio>
						<el-radio v-model="ruleForm.rootUnit" label="否">否</el-radio>
					</div>
				</el-form-item>

				<el-form-item label="医院分级" prop="radio2">
					<div>
						<el-select v-model="ruleForm.radio2" placeholder="医院分级" style="width: 100%;">
							<el-option v-for="item in grade" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div>
				</el-form-item>

				<el-form-item label="最高学历" prop="radio">
					<div>
						<el-radio v-model="ruleForm.radio" label="博士研究生">博士研究生</el-radio>
						<el-radio v-model="ruleForm.radio" label="硕士研究生">硕士研究生</el-radio>
						<el-radio v-model="ruleForm.radio" label="本科">本科</el-radio>
						<el-radio v-model="ruleForm.radio" label="大专">大专</el-radio>
						<el-radio v-model="ruleForm.radio" label="中专">中专</el-radio>
						<el-radio v-model="ruleForm.radio" label="其他">其他</el-radio>
					</div>
				</el-form-item>

				<el-form-item label=" " prop="isIdac">
					<div class="flex">
						<span style="margin-right: 1.25rem;color: #535353;">是否参加4月11日IDAC会议</span>
						<el-radio v-model="ruleForm.isIdac" label="是">是</el-radio>
						<el-radio v-model="ruleForm.isIdac" label="否">否</el-radio>
					</div>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" @click="submitForm('ruleForm')" style="width: 100%;">
						{{this.isonline == "是" || this.isonline==undefined?"线上":"线下"}}参会注册</el-button>
				</el-form-item>
			</el-form>

		</div>
	</div>
</template>

<script>
	import VDistpicker from 'v-distpicker'

	export default {
		data() {

			// 姓名验证
			var name = (rule, value, callback) => {
				console.log(value);
				if (value == '') {
					return callback(new Error('姓名不能为空'));
				}
				return callback();
			};

			// 工作单位验证
			var company = (rule, value, callback) => {
				console.log(value);
				if (value == '') {
					return callback(new Error('工作单位不能为空'));
				}
				return callback();
			};

			// 通讯地址验证
			var postalAddress = (rule, value, callback) => {
				console.log(value);
				if (value == '') {
					return callback(new Error('通讯地址不能为空'));
				}
				return callback();
			};


			// 部门单位验证
			var department = (rule, value, callback) => {
				console.log(value);
				if (value == '') {
					return callback(new Error('工作单位不能为空'));
				}
				return callback();
			};


			// 职称验证
			var title = (rule, value, callback) => {
				console.log(value);
				if (value == '') {
					return callback(new Error('职称不能为空'));
				}
				return callback();
			};

			// 工作单位验证
			var company = (rule, value, callback) => {
				console.log(value);
				if (value == '') {
					return callback(new Error('工作单位不能为空'));
				}
				return callback();
			};
			// 所属地区验证
			var province = (rule, value, callback) => {
				console.log(value)
				if (value == '') {
					return callback(new Error('工作单位不能为空'));
				}
				return callback();
			};

			// 手机验证
			var phoneNumberText = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('手机号码不能为空'));
				} else {
					setTimeout(() => {
						if (!(/^1[3|4|5|8|7][0-9]{9}$/.test(value))) {
							callback(new Error('请输入有效的号码'));
						} else {
							this.$api.judgeUser({
								phone: value
							}, res => {
								if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
									// callback(new Error('该手机号已被注册，请前往登录'));
									var r = confirm("该手机号已被注册，是否前往登录");
									if (r == true) {
										localStorage.removeItem('user');
										this.$router.push({
											path: '/signIn'
										})
									}
								} else {
									return callback();
								}
							});
						}
					}, 500);
				}


			};


			// 身份证验证
			var yzID = (rule, value, callback) => {
				var reg =
					/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
				console.log(value, '999');
				setTimeout(() => {
					if (!(reg.test(value))) {
						callback(new Error('请输入有效的身份证号'));
					} else {
						return callback();
					}

				}, 500);
			};


			// 专业验证
			var gender = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('请选择专业'));
				}
				return callback();
			};
			var radio = (rule, value, callback) => {
				console.log("学历", value);
				if (value == '' || value == null) {
					return callback(new Error('请选择最高学历'));
				}
				return callback();
			};
			var radio2 = (rule, value, callback) => {
				console.log("aa", value);
				if (value == '' || value == null) {
					return callback(new Error('请选择医院分级'));
				}
				return callback();
			};
			var rootUnit = (rule, value, callback) => {
				console.log("是否基层", value);
				if (value == '' || value == null) {
					return callback(new Error('请选择是或否'));
				}
				return callback();
			};
			var isIdac = (rule, value, callback) => {
				console.log("是否参加411会议", value);
				if (value == '' || value == null) {
					return callback(new Error('请选择是或否'));
				}
				return callback();
			};
			// 电子邮箱验证
			var mailbox = (rule, value, callback) => {
				var reg2 = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
				console.log(value, '999');
				setTimeout(() => {
					if (!(reg2.test(value))) {
						callback(new Error('请输入有效的电子邮箱'));
					} else {
						return callback();
					}

				}, 500);
			};



			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					if (this.ruleForm.checkPass !== '') {
						this.$refs.ruleForm.validateField('checkPass');
					}
					callback();
				}
			};

			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.pass) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};


			return {
				isonline: '',
				nickName: '',
				headImg: '',
				openId: '',
				unionId: '',
				state: '',
				ruleForm: {
					id: '',
					pass: '',
					checkPass: '',
					age: '',
					phoneNumber: '',
					name: '',
					field: '',
					mailbox: '',
					company: '',
					postalAddress: '',
					department: '',
					title: '',
					birthday: '',
					radio: '',
					primaryHospital: '',
					radio2: '',
					rootUnit: '',
					isIdac: '',
				},

				// options: [{
				// 	value: '男',
				// 	label: '男'
				// }, {
				// 	value: '女',
				// 	label: '女'
				// }],
				major: [{
						value: '感染病',
						label: '感染病'
					},
					{
						value: '重症医学',
						label: '重症医学'
					},
					{
						value: '呼吸病',
						label: '呼吸病'
					},
					{
						value: '血液病',
						label: '血液病'
					},
					{
						value: '临床微生物',
						label: '临床微生物'
					},
					{
						value: '临床医学/药理学',
						label: '临床医学/药理学'
					},
					{
						value: '医院感染',
						label: '医院感染'
					},
					{
						value: '其他',
						label: '其他'
					},
				],

				grade: [

					{
						value: '三甲',
						label: '三甲',
					}, {
						value: '三乙',
						label: '三乙',
					}, {
						value: '二甲',
						label: '二甲',
					}, {
						value: '二乙',
						label: '二乙',
					},
					{
						value: '二丙',
						label: '二丙',
					},
					{
						value: '一甲',
						label: '一甲',
					}, {
						value: '一乙',
						label: '一乙',
					},
					{
						value: '一丙',
						label: '一丙',
					},
				],

				titleList: [{
					value: '教授',
					label: '教授'
				}, {
					value: '副教授',
					label: '副教授'
				}, {
					value: '讲师',
					label: '讲师'
				}, {
					value: '助教',
					label: '助教'
				}, {
					value: '主任医师',
					label: '主任医师'
				}, {
					value: '副主任医师',
					label: '副主任医师'
				}, {
					value: '住院医师',
					label: '住院医师'
				}, {
					value: '其它',
					label: '其它'
				}],

				rules: {
					pass: [{
						validator: validatePass,
						trigger: 'blur',
						required: true
					}],
					checkPass: [{
						validator: validatePass2,
						trigger: 'blur',
						required: true
					}],
					name: [{
						validator: name,
						trigger: 'blur',
						required: true
					}],
					phoneNumber: [{
						validator: phoneNumberText,
						trigger: 'blur',
						required: true
					}],
					id: [{
						validator: yzID,
						trigger: 'blur',
						required: true
					}],
					radio: [{
						validator: radio,
						trigger: 'change',
						required: true
					}],
					field: [{
						validator: gender,
						trigger: 'change',
						required: true
					}],
					radio2: [{
						validator: radio2,
						trigger: 'change',
						required: true
					}],
					rootUnit: [{
						validator: rootUnit,
						trigger: 'change',
						required: true
					}],
					mailbox: [{
						validator: mailbox,
						trigger: 'blur',
						required: true
					}],
					company: [{
						validator: company,
						trigger: 'blur',
						required: true
					}],
					postalAddress: [{
						validator: postalAddress,
						trigger: 'blur',
						required: true
					}],
					department: [{
						validator: department,
						trigger: 'blur',
						required: true
					}],
					title: [{
						validator: title,
						trigger: 'change',
						required: true
					}],
					province: [{
						validator: province,
						trigger: 'change',
						required: true
					}],
					isIdac: [{
						validator: isIdac,
						trigger: 'change',
						required: true
					}],



				}
			};
		},
		components: {
			VDistpicker
		},
		mounted() {
			this.unionId = this.$route.query.unionId
			this.openId = this.$route.query.openId
			this.nickName = this.$route.query.nickName
			this.headImg = this.$route.query.headImg
			this.isonline = this.$route.query.isonline
			this.state = this.$route.query.selete
			console.log(this.state, 'tiao')
		},
		methods: {

			selected(val) {
				this.ruleForm.province = val.province.value + val.city.value + val.area.value
			},
			submitForm(formName) {
				if (this.ruleForm.province == '' || this.ruleForm.province == null) {
					this.$message.error("请选择你的所属地区")
					return
				}
				let cnt = {
					phone: this.ruleForm.phoneNumber, // String 手机号码
					pwd: this.ruleForm.pass, // String 密码
					name: this.ruleForm.name, // String 姓名
					IDCard: this.ruleForm.id, // String <选填> 身份证号
					field: this.ruleForm.field, // String 专业
					email: this.ruleForm.mailbox, // String 电子邮箱
					district: this.ruleForm.province, // String 所属地区
					company: this.ruleForm.company, // String 工作单位
					companyAddress: this.ruleForm.postalAddress, // String <选填> 通讯地址
					department: this.ruleForm.department, // String 科室部门
					jobTitle: this.ruleForm.title, // String 职称
					BirthDate: this.ruleForm.birthday, // Date 出生日期
					rootUnit: this.ruleForm.rootUnit, //是否来自基层
					highestEducation: this.ruleForm.radio, // String 最高学历
					hospitalLevel: this.ruleForm.radio2, // String 医院分级
					isonline: this.isonline == undefined ? "是" : this.isonline,
					isIdac: this.ruleForm.isIdac, //是否参加411会议
				};

				if (this.unionId != undefined && this.unionId != null && this.unionId != '') {
					cnt.unionId = this.unionId
					cnt.openId = this.openId
				}
				if (this.nickName != undefined && this.nickName != null && this.nickName != '') {
					cnt.nickName = this.nickName
					cnt.headImg = this.headImg
				}
				this.$refs[formName].validate((valid) => {
					console.log('----' + valid)
					if (valid) {
						this.$api.register(cnt, res => {
							if (res.data && res.data.rc == this.$util.RC.SUCCESS) {
								// 接口返回成功数据
								this.$message({
									message: '注册成功',
									type: 'success'
								});
								localStorage.setItem("user", res.data.c);
								if (this.$commen.isWeiXin()) {
									if (this.state == 1) {
										this.$router.push({
											path: '/registerSuccess',
											query: {
												selete: this.state,
												name: '999',
											}
										})
									} else {
										this.$router.push({
											path: '/xx_regist_succ',
											query: {
												selete: this.state,
												name: '999',
											}
										})
									}
								} else if (this.state == 1) {
									this.$router.push({
										path: '/registerSuccess',
										query: {
											selete: this.state,
											name: '999',
										}
									})
								} else {
									this.$router.push({
										path: '/xx_regist_succ',
										query: {
											selete: this.state,
											name: '999',
										}
									})
								}
							} else {
								// 接口返回失败数据
								this.$message.error(res.data.c);
							}
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				})
			},
			retrun: function() {
				this.$router.push({
					path: '/signIn'
				})
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},

		},

	}
</script>

<style lang="scss">
	.head {
		width: 980px;
		margin: 0 auto;
	}

	.retrun {
		margin: 20px 0;
		cursor: pointer;
		color: #4fb3ff;
	}

	.team {
		color: #30b0ff;
		font-size: 15px;
		margin-bottom: 20px;
		font-weight: bold;
		cursor: pointer;
	}

	.retrun:hover {
		color: #49a8eb;
	}

	.zhucbox {
		width: 50%;
		margin: 0 auto;
	}

	@media (max-width: 980px) {
		.head {
			width: 100%;
		}
	}

	@media (max-width: 680px) {
		.zhucbox {
			width: 80%;
			margin: 0 auto;
		}
	}

	@media (max-width: 680px) {
		.distpicker-address-wrapper select {
			display: block;
			margin-top: 10px;
		}
	}
</style>
